export const favourites = [
  {
    title: "The Complete Storiese",
    author: "Flannery O'Connor",
    genre: "Southern Gothic",
    read: "Read in 2023",
    cover: require("../resources/book covers/the-complete-stories.jpg"),
  },
  {
    title: "The Heart Is a Lonely Hunter",
    author: "Carson McCullers",
    genre: "Southern Gothic",
    read: "Read in 2022",
    cover: require("../resources/book covers/the-heart-is-a-lonely-hunter.jpg"),
  },
  {
    title: "One Hundred Years of Solitude",
    author: "Gabriel García Márquez",
    genre: "Magic Realism",
    read: "Read in 2022",
    cover: require("../resources/book covers/one-hundred-years-of-solitude.jpg"),
  },
];
